export default "__VITE_ASSET__DF0_vC6N__"